import { Component, OnInit, ViewChild} from '@angular/core';

import { UserProfileService, ProductData, ProductRouteInfoService } from '../../core';
import { CustomersService } from '../../core/customers.service';
import { DefaultsService } from '../../core/defaults.service';
import { CustomerModel } from '../../core/models/customer-model';
import { AuditStd_DateRangeRules, defaultAuditStd_DateRangeRules } from '../../core/models/rate-audit-settings-model';
import { RateAuditSettingsService } from '../../core/rate-audit-settings.service';
import { AlertComponent, EnumAlertType } from '../../common/component/alert/alert.component';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss']
  })
export class ConfigurationComponent implements OnInit {
    @ViewChild(AlertComponent, { static: true }) alertController: AlertComponent;

  public hasRateAuditAccess = false;
  public customerObj: CustomerModel = null;
  receivedChildMessage:string;
  public barKeywords: string = "";
  public comparisonKeywords: string="";
  public displayComparisonKeywords: boolean = true;
  public rateAuditSettingsObj: AuditStd_DateRangeRules = defaultAuditStd_DateRangeRules();


  selectedTab:string = "barKeywords";

  //need to initialize with junk data to avoid null pointer exceptions when loading the page
  public dateRangeSelectArray:Array<{number:{text:string,value:number},day:{text:string,value:number}}> = [
    {
      number:{text:'',value:-1},
      day:{text:'',value:-1}
    },
    {
      number:{text:'',value:-1},
      day:{text:'',value:-1}
    },
    {
      number:{text:'',value:-1},
      day:{text:'',value:-1}
    },
    {
      number:{text:'',value:-1},
      day:{text:'',value:-1}
    },
    {
      number:{text:'',value:-1},
      day:{text:'',value:-1}
    }
  ];
  public dateRangeNumberSelection:Array<{text:string,value:number}> = [
    {text:'First',value:1},
    {text:'Second',value:2},
    {text:'Third',value:3},
    {text:'Fourth',value:4}
  ];
  public dateRangeDaySelection:Array<{text:string,value:number}> = [
    {text:'Sunday',value:0},
    {text:'Monday',value:1},
    {text:'Tuesday',value:2},
    {text:'Wednesday',value:3},
    {text:'Thursday',value:4},
    {text:'Friday',value:5},
    {text:'Saturday',value:6}
  ];
  public pointOfIssue:number;
  public message:string;
  public quotes:string[] = ['"',','];
  public isInvalidBarKeyword:boolean=false;

  constructor(private userProfileService:UserProfileService,
              private productRouteInfoService: ProductRouteInfoService,
              private customerService: CustomersService,
              private rateAuditSettingsService: RateAuditSettingsService,
              private defaultsService: DefaultsService) { }

  ngOnInit() {

    let user = this.userProfileService.data;
    var accountTypesForComparisonKeywords:Array<string>= ["Master","Consortia Advanced","Corporation"]
    this.displayComparisonKeywords =  accountTypesForComparisonKeywords.includes( user.CustomerType);
    this.hasRateAuditAccess = user.ProductAccess.indexOf('RateAudit') > -1;

    this.customerService.GetCustomer().subscribe(data =>
    {
      this.customerObj = data;
      this.barKeywords = this.customerObj.BARKeywords;
      this.comparisonKeywords = this.customerObj.ComparisonKeywords;

    });

    this.rateAuditSettingsService.Get().subscribe(data =>
    {
      this.rateAuditSettingsObj = data;
      this.dateRangeSelectArray[0].number = {
        text : this.dateRangeNumberSelection[data.DOW1-1].text,
        value : data.DOW1
      };
      this.dateRangeSelectArray[0].day = {
        text : this.dateRangeDaySelection[data.DOWIndex1].text,
        value : data.DOWIndex1
      };
      this.dateRangeSelectArray[1].number = {
        text : this.dateRangeNumberSelection[data.DOW2-1].text,
        value : data.DOW2
      };
      this.dateRangeSelectArray[1].day = {
        text : this.dateRangeDaySelection[data.DOWIndex2].text,
        value : data.DOWIndex2
      };
      this.dateRangeSelectArray[2].number = {
        text : this.dateRangeNumberSelection[data.DOW3-1].text,
        value : data.DOW3
      };
      this.dateRangeSelectArray[2].day = {
        text : this.dateRangeDaySelection[data.DOWIndex3].text,
        value : data.DOWIndex2
      };
      this.dateRangeSelectArray[3].number = {
        text : this.dateRangeNumberSelection[data.DOW4-1].text,
        value : data.DOW4
      };
      this.dateRangeSelectArray[3].day = {
        text : this.dateRangeDaySelection[data.DOWIndex4].text,
        value : data.DOWIndex4
      };
      this.dateRangeSelectArray[4].number = {
        text : this.dateRangeNumberSelection[data.DOW5-1].text,
        value : data.DOW5
      };
      this.dateRangeSelectArray[4].day = {
        text : this.dateRangeDaySelection[data.DOWIndex5].text,
        value : data.DOWIndex5
      };
    });
  }

  loadDefaultBARKeywords() {
    this.barKeywords = this.defaultsService.GetDefaultBarKeywords();
    return false;
  }

  OnDateRangeNumberSelectionChanged(value:{ text: string, value: number }, index:number){
    this.dateRangeSelectArray[index].number = {
      text : value.text,
      value : value.value
    };
    //store the value that was just changed to the object that gets saved to the server when
    //Save button is clicked
    if(index==0) {
      this.rateAuditSettingsObj.DOW1 = value.value;
    } else if(index==1) {
      this.rateAuditSettingsObj.DOW2 = value.value;
    } else if(index==2) {
      this.rateAuditSettingsObj.DOW3 = value.value;
    } else if(index==3) {
      this.rateAuditSettingsObj.DOW4 = value.value;
    } else if(index==4) {
      this.rateAuditSettingsObj.DOW5 = value.value;
    }
  }

  OnDateRangeDaySelectionChanged(value:{ text: string, value: number }, index:number){
    this.dateRangeSelectArray[index].day = {
      text : value.text,
      value : value.value
    };
    //store the value that was just changed to the object that gets saved to the server when
    //Save button is clicked
    if(index==0) {
      this.rateAuditSettingsObj.DOWIndex1 = value.value;
    } else if(index==1) {
      this.rateAuditSettingsObj.DOWIndex2 = value.value;
    } else if(index==2) {
      this.rateAuditSettingsObj.DOWIndex3 = value.value;
    } else if(index==3) {
      this.rateAuditSettingsObj.DOWIndex4 = value.value;
    } else if(index==4) {
      this.rateAuditSettingsObj.DOWIndex5 = value.value;
    }
  }

  saveBarKeywords() {
    this.isInvalidBarKeyword=false;
    if(this.barKeywords.length > 1024) {
      this.isInvalidBarKeyword=true;
      this.alertController.showAlertMessage(5000, "The BAR Keywords Expression is " + this.barKeywords.length + " characters long, shorten it to 1024 characters", EnumAlertType.Error);
      return false;
    }
    var pattern = new RegExp(/[~`!#$%\^&*+=\-\[\]\\';@/{}|\\:<>\?]/); //unacceptable chars
    if(pattern.test( this.barKeywords )){
      this.isInvalidBarKeyword=true;
      this.alertController.showAlertMessage(5000, "The BAR Keywords Expression contains special characters other than , and "+'"' , EnumAlertType.Error);
      return false;
    }
    if(this.isInvalidBarKeyword==false){
      var goodPortion= this.validateBARKeywords(this.barKeywords);
      this.customerObj.BARKeywords = this.barKeywords;

      if(this.message=="" && this.isInvalidBarKeyword==false){
      this.customerService.UpdateCustomer(this.customerObj)
          .subscribe(()=>{
            this.alertController.showAlertMessage(5000, "BAR Keywords were saved successfully!", EnumAlertType.Success);
          },
          (err)=> {
            this.alertController.showAlertMessage(5000, "Unable to save BAR Keywords. Please contact customer care for more assistance", EnumAlertType.Error);
          });
      }
      else{
        this.alertController.showAlertMessage(5000, "Bad comma separated BAR keyword expression. Found " + this.message + ". Valid portion of expression was " + goodPortion
        , EnumAlertType.Error);

      }
    }

    return false;
  }

  validateBARKeywords(word:string){

    this.pointOfIssue = -1;
    this.message = "";
    this.isInvalidBarKeyword=false;
    word = word.trim();

    if (word)
    {
        var end = word.length;
        var nextComma = word.indexOf(",");
        var nextQuote = word.indexOf(this.quotes[0]);
        var loopTest = 0;
        var startNextPhrase = 0;
        while (nextComma != -1 || nextQuote != -1)
        {
            if (nextQuote == -1 || (nextComma != -1 && nextComma < nextQuote))
            {
                startNextPhrase = nextComma + 1;
                if (startNextPhrase >= end)
                {
                    this.pointOfIssue = startNextPhrase - 1;
                    this.message = "a hanging comma";
                    this.isInvalidBarKeyword=true;
                    break;
                }
                nextComma = word.indexOf(",", startNextPhrase);
            }
            else //nextQuote is first or only
            {
                startNextPhrase = nextQuote + 1;
                if (startNextPhrase >= end)
                {
                    this.pointOfIssue = startNextPhrase - 1;
                    this.message = "an unmatched quote";
                    this.isInvalidBarKeyword=true;
                    break; //
                }
                var matchQuote = word.indexOf(this.quotes[0], startNextPhrase);
                if (matchQuote == -1)
                {
                    this.pointOfIssue = startNextPhrase - 1;
                    this.message = "an unmatched quote";
                    this.isInvalidBarKeyword=true;
                    break; //unmatched quote
                }
                startNextPhrase = matchQuote + 1;
                if (startNextPhrase >= end)
                    break;//good
                nextQuote = word.indexOf(this.quotes[0], startNextPhrase);
            }
            if (loopTest == startNextPhrase)
                break;
            loopTest = startNextPhrase;
        }
      }
      return word.substring(0, this.pointOfIssue == -1 ? word.length : this.pointOfIssue);
  }
  saveRateAuditSettings()
  {
    if(this.receivedChildMessage != undefined)
    {
      this.customerObj.ComparisonKeywords = this.receivedChildMessage;
    }
    this.customerService.UpdateCustomer(this.customerObj)
          .subscribe(()=>{
           },
          (err)=> {
            this.alertController.showAlertMessage(5000, "Unable to save Comparison Keywords. Please contact customer care for more assistance", EnumAlertType.Error);
          });


    this.rateAuditSettingsService.Save(this.rateAuditSettingsObj)
        .subscribe(()=>{
          this.alertController.showAlertMessage(5000, "Rate Audit Settings were saved successfully!", EnumAlertType.Success);
        },
        (err)=> {
          this.alertController.showAlertMessage(5000, "Unable to save Rate Audit Settings. Please contact customer care for more assistance", EnumAlertType.Error);
        });
    return false;
  }

  getMessage(commaSepKeywords: string)
  {
  this.receivedChildMessage=commaSepKeywords;
  }
}
